<template>
    <div class="card">
        <h5 class="m-0 md:mb-2 block lg:hidden">Create Health Article</h5>
        <form class="p-fluid" @submit.prevent="handleSubmit()">
            <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                    <label for="title" :class="{ 'p-error': formError.titleEn && submitted }" class="font-bold">{{ $t('Title (English)') }}<span class="p-error">*</span></label>
                    <InputText id="title" v-model="state.titleEn" placeholder="Health Article title" class="w-full mt-2" />
                    <small v-if="formError.titleEn" class="p-error">
                        <div>{{ formError.titleEn }}</div>
                    </small>
                </div>
                <div class="field col-12 md:col-12 lg:col-12">
                    <label for="entries" class="font-bold">Health Article (English)</label>
                    <Editor v-model="state.contentEn" editorStyle="height: 200px">
                        <template #toolbar>
                            <span class="ql-formats">
                                <label for="health-article-toolbar-header" class="p-sr-only">Heading</label>
                                <select id="health-article-toolbar-header" class="ql-header" defaultValue="0">
                                    <option value="1">Heading</option>
                                    <option value="2">Subheading</option>
                                    <option value="0">Normal</option>
                                </select>
                                <label for="health-article-toolbar-font" class="p-sr-only">Font</label>
                                <select id="health-article-toolbar-font" class="ql-font">
                                    <option></option>
                                    <option value="serif"></option>
                                    <option value="monospace"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-bold" type="button"></button>
                                <button class="ql-italic" type="button"></button>
                                <button class="ql-underline" type="button"></button>
                            </span>
                            <span class="ql-formats">
                                <label for="health-article-toolbar-color" class="p-sr-only">Text color</label>
                                <select id="health-article-toolbar-color" class="ql-color"></select>
                                <label for="health-article-toolbar-background" class="p-sr-only">Background color</label>
                                <select id="health-article-toolbar-background" class="ql-background"></select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" value="ordered" type="button"></button>
                                <button class="ql-list" value="bullet" type="button"></button>
                                <label for="health-article-toolbar-align" class="p-sr-only">Alignment</label>
                                <select id="health-article-toolbar-align" class="ql-align">
                                    <option defaultValue></option>
                                    <option value="center"></option>
                                    <option value="right"></option>
                                    <option value="justify"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-link" type="button"></button>
                                <button class="ql-code-block" type="button"></button>
                            </span>

                            <span class="ql-formats">
                                <button class="ql-image" type="button"></button>
                            </span>
                        </template>
                    </Editor>
                    <small v-if="errors.has('content')" class="p-error">
                        <div v-for="error in errors.get('content')" :key="error">
                            {{ error }}
                        </div>
                    </small>
                </div>
                <div class="col-12 md:col-12 lg:col-12">
                    <label for="title_mm" :class="{ 'p-error': formError.titleMm && submitted }" class="font-bold">{{ $t('Title (Myanmar)') }}<span class="p-error">*</span></label>
                    <InputText id="title_mm" v-model="state.titleMm" placeholder="Content title" class="w-full mt-2" />
                    <small v-if="formError.titleMm" class="p-error">
                        <div>
                            {{ formError.titleMm }}
                        </div>
                    </small>
                </div>
                <div class="field col-12 md:col-12 lg:col-12">
                    <label for="entries" class="font-bold">Content (Myanmar)</label>
                    <Editor v-model="state.contentMm" editorStyle="height: 200px"> </Editor>
                    <small v-if="errors.has('content')" class="p-error">
                        <div v-for="error in errors.get('content')" :key="error">
                            {{ error }}
                        </div>
                    </small>
                </div>
                <div class="field col-12 md:col-6 lg:col-6">
                    <label for="category_id" class="font-bold" :class="{ 'p-error': v$.category_id.$invalid && submitted }">{{ $t('Category') }}<span class="p-error">*</span> </label>
                    <Dropdown id="id" v-model="state.category_id" :options="optionsCategory" optionLabel="name" optionValue="id" placeholder="Select category" class="w-full" />
                    <small v-if="errors.has('category_id')" class="p-error">
                        <div v-for="error in errors.get('category_id')" :key="error">
                            {{ error }}
                        </div>
                    </small>
                </div>
                <div class="field col-12 md:col-6 lg:col-6">
                    <label for="health-article-published-at" class="font-bold"> Published At </label>
                    <Calendar inputId="health-article-published-at" class="w-full" :showIcon="true" dateFormat="yy-mm-dd" :minDate="new Date()" v-model="state.published_at" placeholder="Choose published Date" />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="user_type" class="font-bold">User Type</label>
                    <div class="grid mt-2 ml-2">
                        <div class="flex field-checkbox pr-4" v-for="user of optionsUserType" :key="user.code">
                            <RadioButton :inputId="user.code" name="user" :value="user.code" v-model="v$.user_type.$model" />
                            <label :for="user.code">{{ user.name }}</label>
                        </div>

                        <!-- Server Validation -->
                        <small v-if="errors.has('type')" class="p-error">
                            <div v-for="error in errors.get('type')" :key="error">
                                {{ error }}
                            </div>
                        </small>
                        <!-- Server Validation -->
                    </div>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <label for="post_type" class="font-bold">Post Type</label>
                    <div class="grid mt-2 ml-2">
                        <div class="flex field-radiobutton pr-4" v-for="post of optionsPostType" :key="post.code">
                            <RadioButton :inputId="post.code" name="post" :value="post.code" v-model="v$.post_type.$model" />
                            <label :for="post.code">{{ post.name }}</label>
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-6 lg:col-6">
                    <label for="health-article-expired-at" class="font-bold" :class="{ 'p-error': v$.expired_at.$invalid && submitted }"> Expired At </label>
                    <Calendar inputId="health-article-expired-at" class="w-full" :showIcon="true" dateFormat="yy-mm-dd" v-model="state.expired_at" :minDate="new Date(Date.now() + 1 * 86400000)" placeholder="Choose expired Date" />
                </div>

                <div class="col-6 md:col-6 lg:col-6">
                    <label for="title" class="font-bold">{{ $t('Video Url') }}</label>
                    <InputText id="url" v-model="state.video_url" placeholder="Video Url" class="w-full mt-2" />
                </div>

                <div class="col-6 md:col-6 lg:col-6"></div>

                <div class="field col-12 md:col-6 lg:col-6">
                    <label class="font-bold" for="photo" :class="{ 'p-error': v$.photo.$invalid && submitted }">{{ $t('photo') }}<span class="p-error">*</span></label>
                    <FileUpload mode="basic" accept="image/*" :maxFileSize="1000000" :chooseLabel="photoURL ? 'Change' : 'Browse'" :customUpload="true" :auto="true" uploadIcon="ri-upload-2-fill" @uploader="onUpload($event)" />
                    <div class="field mt-3">
                        <Image :src="photoURL" alt="Image" width="200" height="200" preview />
                    </div>
                    <small v-if="(v$.photo.$invalid && submitted) || v$.photo.$pending.$response" class="p-error">{{ v$.photo.required.$message.replace('Value', 'Content Photo') }}</small>
                    <span v-if="imgErrorMessage" class="error">{{ imgErrorMessage }}</span>
                </div>
            </div>
            <div class="col-12 md:col-12 flex justify-content-start">
                <div class="flex pr-4" v-if="$can('create', 'health-article')">
                    <Button type="submit" label="Save as Draft" @click="onClickDraft()" class="mt-2 p-button-primary p-button-filled" />
                </div>
                <div class="flex pr-4" v-if="$can('publish', 'health-article')">
                    <Button type="submit" label="Publish" @click="onClickPublish()" class="mt-2 p-button-success p-button-outlined" />
                </div>
                <div class="flex pr-4">
                    <router-link v-if="$can('view', 'health-article')" :to="{ name: 'healthArticleList' }">
                        <div>
                            <Button :label="$t('cancel')" class="mt-2 p-button-outlined p-button-secondary" />
                        </div>
                    </router-link>
                </div>
            </div>
        </form>
        <Dialog header="Crop Image" v-model:visible="showCropDialog" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '50vw' }">
            <div class="p-4">
                <cropper
                    class="cropper"
                    v-if="photo"
                    :src="photo"
                    :stencil-props="{
                        aspectRatio: 1 / 1
                    }"
                    @change="cropImage"
                ></cropper>
            </div>
            <template #footer>
                <Button label="Got it" @click="showCropDialog = false" autofocus />
            </template>
        </Dialog>

        <Loading v-if="isLoading"></Loading>
    </div>
</template>

<script>
// import BlockUI from "primevue/blockui";
import Button from 'primevue/button'
import FileUpload from 'primevue/fileupload'
import InputText from 'primevue/inputtext'
import Loading from '@/components/Loading.vue'
import RadioButton from 'primevue/radiobutton'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import Editor from 'primevue/editor'
import { Cropper } from 'vue-advanced-cropper'
import { defineComponent } from 'vue'
// import Checkbox from 'primevue/checkbox'
import Image from '@/components/Image'
import Calendar from 'primevue/calendar'
import { useNewHealthArticle } from '@/modules/health_article/entry/useNew'

import 'vue-advanced-cropper/dist/style.css'

export default defineComponent({
    name: 'NewContent',
    components: {
        Loading,
        // Checkbox,
        FileUpload,
        Image,
        RadioButton,
        Calendar,
        Button,
        InputText,
        Dialog,
        Cropper,
        Dropdown,
        Editor
    },
    setup() {
        const {
            formError,
            isLoading,
            RadioButton,
            state,
            submitted,
            handleSubmit,
            onClickDraft,
            onClickPublish,
            errors,
            optionsUserType,
            optionsCategory,
            crop_photo,
            optionsPostType,
            cropImage,
            postType,
            showCropDialog,
            takePicture,
            photoURL,
            onUpload,
            v$,
            photo,
            imgErrorMessage
        } = useNewHealthArticle()

        return {
            formError,
            isLoading,
            state,
            onUpload,
            submitted,
            onClickDraft,
            RadioButton,
            onClickPublish,
            handleSubmit,
            errors,
            FileUpload,
            optionsUserType,
            postType,
            v$,
            optionsPostType,
            optionsCategory,
            crop_photo,
            photoURL,
            cropImage,
            showCropDialog,
            takePicture,
            photo,
            imgErrorMessage
        }
    }
})
</script>
<style lang="scss" scoped>
.card-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.error {
    color: red;
}
</style>
